import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { ConnectAccountWizardHeaderProps } from './ConnectAccountWizardHeader';

export const SelectAdvertisingProfileStepHeader: FC<ConnectAccountWizardHeaderProps> = () => {
  return <Typography variant={'h5'}>Select an Advertising Profile</Typography>;
};
